import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';

const ScrollbarCustom = ({ children, className }) => {
  return (
    <S.ScrollBar
      className={className}
      mobileNative
      momentum={false}
      scrollerProps={{
        // eslint-disable-next-line react/prop-types
        renderer: ({ elementRef, ...restProps }) => (
          <S.Scroller {...restProps} ref={elementRef} />
        ),
      }}
      wrapperProps={{
        // eslint-disable-next-line react/prop-types
        renderer: ({ elementRef, ...restProps }) => {
          return <S.Wrapper {...restProps} ref={elementRef} />;
        },
      }}
      trackYProps={{
        // eslint-disable-next-line react/prop-types
        renderer: ({ elementRef, ...restProps }) => {
          return <S.Track {...restProps} ref={elementRef} />;
        },
      }}
      contentProps={{
        // eslint-disable-next-line react/prop-types
        renderer: ({ elementRef, ...restProps }) => {
          return <S.Content {...restProps} ref={elementRef} />;
        },
      }}
    >
      {children}
    </S.ScrollBar>
  );
};

ScrollbarCustom.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ScrollbarCustom.defaultProps = {
  children: null,
  className: null,
};

export default ScrollbarCustom;
